import types from './types';

const reducer = (state, action) => {
  switch (action.type) {
    case types.SET_LOADING_STATUS:
      return {
        ...state,
        isLoading: action.payload,
      };
    case types.SET_WEB_SHEETS_DATA:
      return {
        ...state,
        isLoading: false,
        webSheets: {
          ...state.webSheets,
          [action.payload.brandId]: action.payload,
        },
      };
    default:
      throw new Error(`Unknown type dispatch ${action.type}`);
  }
};

export default reducer;
